import axios from 'axios'
const baseURL = process.env.VUE_APP_API_URL_COMMON

const apiRequestCommon = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  },
  data: {}
})

apiRequestCommon.interceptors.response.use(
  res => {
    return res
  },
  err => {
    return Promise.reject(err)
  }
)

export default apiRequestCommon
